var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"embed-responsive"},[_c('Title',{attrs:{"title-name":_vm.pageTitle.titleName,"title-link":_vm.pageTitle.titleLink}}),_c('div',{staticClass:"container-fluid"},[_c('iframe',{staticStyle:{"margin-top":"54px"},attrs:{"src":_vm.iframeUrl,"allowfullscreen":""}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }